import(/* webpackMode: "eager" */ "/home/runner/work/online-booking-v3/online-booking-v3/src/app/not-found.tsx");
